/**
 * Versão do app que está rodando neste navegador.
 *
 * Vem da tag da imagem, assada no build (`VITE_APP_VERSION`, argumento `VERSAO`
 * do Dockerfile). Em desenvolvimento não existe imagem nenhuma e fica "dev" —
 * melhor do que fingir um número que ninguém conferiu.
 *
 * Existe porque frontend e backend sobem separados: o service worker pode
 * estar servindo um bundle antigo enquanto a API já é nova, e sem ver os dois
 * números lado a lado não há como desconfiar disso.
 */
export const VERSAO_DO_APP: string = import.meta.env.VITE_APP_VERSION ?? 'dev';

/**
 * Força este aparelho a pegar a versão nova.
 *
 * O service worker guarda o bundle para o app abrir rápido (e é o que faz o
 * PWA valer a pena no celular). O efeito colateral é que, depois de um deploy,
 * o aparelho continua no bundle velho até ele se atualizar sozinho — e não há
 * como saber que é isso que está acontecendo. Aqui a gente derruba o registro
 * e os caches e recarrega, que é o conserto manual que eu faria no DevTools.
 *
 * Tolerante a falha de propósito: em contexto sem service worker (http que não
 * é localhost, navegador antigo) os acessos lançam, e recarregar ainda é o
 * melhor que se pode fazer.
 */
export async function atualizarOApp(): Promise<void> {
  try {
    const registros = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    await Promise.all(registros.map((registro) => registro.unregister()));
    const nomes = await caches.keys();
    await Promise.all(nomes.map((nome) => caches.delete(nome)));
  } catch {
    // Sem service worker não há cache para limpar: recarregar basta.
  }
  window.location.reload();
}
